import { Corporate } from 'modules/corporate/types/corporates'

interface Props {
  corporate: Corporate
}

export const getIsKycStarted = ({ corporate }: Props) => {
  return corporate.subscriptions && corporate.subscriptions.length > 0
}
